import { render, staticRenderFns } from "./BuildingEditRoomsTab.vue?vue&type=template&id=71f63672"
import script from "./BuildingEditRoomsTab.vue?vue&type=script&lang=ts"
export * from "./BuildingEditRoomsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports